import React from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import ContactsList from "./Features/ContactsList";
import ContactsAction from "./Features/ContactsActions";

const ContactDetails = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));

  return (
    <Box
      sx={{
        minHeight: 0,
        flex: 1,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        backgroundColor: (theme) => theme.palette.background.default,
        color: (theme) => theme.palette.text.primary,
      }}
    >
      {/* Action Bar for xs screens - above the contacts list */}
      {isXs && (
        <Box
          sx={{
            width: "100%",
            borderBottom: 1,
            borderColor: 'divider',
            backgroundColor: (theme) => theme.palette.background.paper,
            paddingLeft: "8px", // Add left padding for xs screens
            paddingRight: "8px", // Add right padding for xs screens
            boxSizing: "border-box",
            flexShrink: 0,
          }}
        >
          <ContactsAction isCompact={true} />
        </Box>
      )}

      {/* Main Content — single scroll owner inside child table containers */}
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          width: "100%",
          maxWidth: "100%",
          display: "flex",
          flexDirection: "column",
          backgroundColor: (theme) => theme.palette.background.default,
          overflow: "hidden",
          overflowX: { xs: "hidden", sm: "hidden", md: "auto", lg: "auto", xl: "auto" },
          paddingLeft: { xs: 0, sm: "12px", md: 1.5, lg: 1.5, xl: 2 }, // Removed padding for xs
          paddingRight: { xs: 0, sm: "12px", md: 1.5, lg: 1.5, xl: 2 }, // Removed padding for xs
          boxSizing: "border-box",
          "&::-webkit-scrollbar": {
            width: { xs: "4px", sm: "4px", md: "4px", lg: "4px", xl: "4px" },
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: (theme) => theme.palette.mode === "dark" ? "#1E1E1E" : "#f1f1f1",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: (theme) => theme.palette.mode === "dark" ? "#888" : "#888",
            borderRadius: "3px",
            "&:hover": {
              backgroundColor: (theme) => theme.palette.mode === "dark" ? "#aaa" : "#aaa",
            },
          },
        }}
      >
        <ContactsList />
      </Box>
    </Box>
  );
};

export default ContactDetails;
